import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import authService from '../services/authService'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "products" */ '../views/ProductsView.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ '../views/MobileCartView.vue')
  },
  {
    path: '/product/:id?',
    name: 'mobile-product',
    component: () => import(/* webpackChunkName: "mobile-product" */ '../views/MobileProductView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/add-client',
    name: 'add-client',
    component: () => import(/* webpackChunkName: "add-client" */ '../views/AddClientView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/add-product',
    name: 'add-product',
    component: () => import(/* webpackChunkName: "add-product" */ '../views/AddProductView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/add-order',
    name: 'add-order',
    component: () => import(/* webpackChunkName: "add-order" */ '../views/AddOrderView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test-storage',
    name: 'test-storage',
    component: () => import(/* webpackChunkName: "test-storage" */ '../views/TestStorageView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to protect authenticated routes
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = authService.isAuthenticated();

  if (requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }
});

export default router
